import { Typography } from '@material-ui/core';
import React, { FC } from 'react';

const Copyright: FC = () => (
  <Typography align="center" variant="body2">
    © 2019 Code Savvy
  </Typography>
);

export default Copyright;
